
import React, { useEffect, useState, useCallback, useRef } from "react";
import { Dropdown, Modal, Button, Tabs, Tab , Card, Row, Col, ButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import Spinner from "../components/Common/Spinner";
import {
  addFile,
  createNewAdmin,
  deleteAdmin,

  getUrl,
  updateAdminInfo,
  updateAdminStatus,
  verifyUser,
 
} from "../../services/Admin/adminServices";

import Pagination from "../components/Pagination";
import { useFetcher, useNavigate, useLocation } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { getMISList, getSafetyChecks, getUserList, getWaitList, exportSafetyCheckList } from "../../services/UserServices/UserService";
import LocationSearchDropdown from "../components/LocationAdd";
import { useSelector } from "react-redux";

const ReadMoreContacts = ({ contacts }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!contacts || contacts.length === 0) return "_";

  const formattedContacts = contacts.map(
    (c) => `${c.name.charAt(0).toUpperCase() + c.name.slice(1)} (${c.phoneNumber})`
  );

  const firstContact = formattedContacts[0];
  const hasMultiple = contacts.length > 1;
  const isLong = firstContact.length > 25 || hasMultiple;

  if (!isLong) {
    return <span>{firstContact}</span>;
  }

  return (
    <div style={{ maxWidth: isExpanded ? "350px" : "250px", wordBreak: "break-word" }}>
      {isExpanded ? (
        <div>
          {formattedContacts.map((c, i) => (
            <div key={i}>{c}</div>
          ))}
          <button
            type="button"
            className="btn btn-link p-0 text-primary fw-semibold mt-1"
            style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(false);
            }}
          >
            Read Less
          </button>
        </div>
      ) : (
        <div>
          {firstContact.length > 25 ? `${firstContact.slice(0, 25)}...` : firstContact}
          {hasMultiple && ` (+${contacts.length - 1} more)`}
          <button
            type="button"
            className="btn btn-link p-0 text-primary fw-semibold ms-1"
            style={{ fontSize: "12px", textDecoration: "none", boxShadow: "none", verticalAlign: "baseline" }}
            onClick={(e) => {
              e.stopPropagation();
              setIsExpanded(true);
            }}
          >
            Read More
          </button>
        </div>
      )}
    </div>
  );
};
 
const MetricCard = ({ title, value, icon }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    // 1. Strip commas if the value is passed as a string (e.g., "1,500")
    const target = typeof value === "number" ? value : parseFloat(value?.toString()?.replace(/,/g, ""));

 
    if (isNaN(target)) {
      setCount(value);
      return;
    }

    let startTimestamp = null;
    const duration = 1500; // Animation time in milliseconds (1.5 seconds)

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      // 3. Easing function (easeOutExpo) for a smooth slow-down effect at the end
      const easeOut = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      
      setCount(Math.floor(easeOut * target));

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        setCount(target); // Ensure it lands exactly on the final number
      }
    };

    window.requestAnimationFrame(step);
  }, [value]);

  // 4. Format the final output with commas (e.g., 1000000 -> 10,00,000)
  const displayValue = typeof count === "number" ? count.toLocaleString("en-IN") : count;

  return (
    <Card className="p-3 mb-3 shadow-sm border-0 " style={{ backgroundColor: "#fff", borderRadius: "1.36rem" }}>
      <div className="d-flex align-items-start" style={{ paddingTop: "1.99rem", paddingBottom: "1.99rem" }}>
        <div 
          className="d-flex justify-content-center align-items-center rounded-circle me-3" 
          style={{ width: "48px", height: "48px", backgroundColor: "#FFE4E6", color: "#E5484D" }}
        >
          {icon}
        </div>
        <div>
          <h6 className="text-muted mb-1" style={{ fontSize: "0.99rem", fontWeight: "normal" }}>{title}</h6>
          <h4 className="mb-2" style={{ fontSize: "1.45rem" }}>
            {displayValue}
          </h4>
        </div>
      </div>
    </Card>
  );
};
const SafetyChecks = () => {
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
const [locationText, setLocationText] = useState("");
const [coordinates, setCoordinates] = useState({
    lat: "",
    long: "",
  });
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
   const [deleteReason, setDeleteReason] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showExportModal, setShowExportModal] = useState(false);
  const [exportType, setExportType] = useState("excel");
  const [exportStartDate, setExportStartDate] = useState("");
  const [exportEndDate, setExportEndDate] = useState("");
  const [exportStatus, setExportStatus] = useState("");
  const [exportLoading, setExportLoading] = useState(false);

  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage ?? 0
  );
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "User"
  );
  const [type, setType] = useState("");
 
  const [confirmState, setConfirmState] = useState({
    show: false,
    action: null,
    id: null,
    status: null,
    message: "",
  });
 const navigate = useNavigate();
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [imageLoading, setImageLoading] = useState(false);
  const [submit, setSubmit] = useState(false);
 const roleData = useSelector(
    (state) => state.role.roles
  );
   const user = useSelector(
    (state) => state.role.user
  );
  const topMetrics = [
  {
    title: "Total Registered Users",
    value: 10,
    icon: (
     <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.3106 7.15719C20.7902 8.08488 21.8277 9.65473 22.0166 11.477C22.62 11.7589 23.2898 11.921 23.9998 11.921C26.592 11.921 28.693 9.82006 28.693 7.22827C28.693 4.63608 26.592 2.5351 23.9998 2.5351C21.4324 2.53589 19.3498 4.59934 19.3106 7.15719ZM16.236 16.7664C18.8282 16.7664 20.9292 14.665 20.9292 12.0732C20.9292 9.48141 18.8278 7.38042 16.236 7.38042C13.6442 7.38042 11.542 9.48181 11.542 12.0736C11.542 14.6654 13.6442 16.7664 16.236 16.7664ZM18.2268 17.0863H14.2445C10.931 17.0863 8.23542 19.7823 8.23542 23.0957V27.9658L8.2478 28.042L8.58325 28.1471C11.7453 29.1351 14.4924 29.4645 16.7536 29.4645C21.17 29.4645 23.7298 28.2054 23.8876 28.1251L24.2011 27.9666H24.2346V23.0957C24.2358 19.7823 21.5402 17.0863 18.2268 17.0863ZM25.9914 12.2413H22.0398C21.9971 13.8224 21.3222 15.246 20.2547 16.27C23.1999 17.1458 25.3548 19.8769 25.3548 23.1029V24.6036C29.2565 24.4607 31.5048 23.3549 31.653 23.2806L31.9665 23.1216H32V18.25C32 14.9369 29.3044 12.2413 25.9914 12.2413ZM8.001 11.9218C8.91911 11.9218 9.77332 11.6539 10.4969 11.1974C10.727 9.69706 11.5313 8.38599 12.6802 7.49304C12.685 7.40518 12.6934 7.31812 12.6934 7.22947C12.6934 4.63728 10.592 2.53629 8.001 2.53629C5.40841 2.53629 3.30782 4.63728 3.30782 7.22947C3.30782 9.82046 5.40841 11.9218 8.001 11.9218ZM12.2157 16.27C11.1535 15.2512 10.481 13.8351 10.4318 12.2637C10.2853 12.2529 10.1403 12.2413 9.99096 12.2413H6.00904C2.69562 12.2413 0 14.9369 0 18.25V23.1208L0.0123799 23.1959L0.347835 23.3018C2.88451 24.0937 5.14843 24.4587 7.11484 24.5737V23.1029C7.11564 19.8769 9.26974 17.1466 12.2157 16.27Z" fill="#E5484D"/>
</svg>

    ),
  },
  {
    title: "Unverified User",
    value: 20,
    icon: (
     <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 2C11.9291 2 8.61719 5.31193 8.61719 9.38281C8.61719 13.4537 11.9291 16.7656 16 16.7656C20.0709 16.7656 23.3828 13.4537 23.3828 9.38281C23.3828 5.31193 20.0709 2 16 2Z" fill="#E5484D"/>
<path d="M25.1856 21.5888C23.1644 19.5365 20.4849 18.4062 17.6406 18.4062H14.3594C11.5152 18.4062 8.83561 19.5365 6.81436 21.5888C4.80301 23.631 3.69531 26.3268 3.69531 29.1797C3.69531 29.6327 4.06259 30 4.51562 30H27.4844C27.9374 30 28.3047 29.6327 28.3047 29.1797C28.3047 26.3268 27.197 23.631 25.1856 21.5888Z" fill="#E5484D"/>
</svg>

    ),
  },]
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const fetchAdmins = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getSafetyChecks(
        currentPage,
        itemsPerPage,
        type
       );
 

      setAdmins(response?.data?.data?.data );
       
      setTotalItems(response?.data?.data?.total || 0);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    itemsPerPage,
   type
  ]);
 useEffect(() => {
    fetchAdmins();
  }, [fetchAdmins]);
 useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearch(search.trim());
    }, 500);
  return () => clearTimeout(timeoutId);
  }, [search]);
  useEffect(() => {
    if (currentPage !== undefined) {
      navigate(".", {
        replace: true,
        state: { ...location.state, currentPage, activeTab },
      });
    }
  }, [currentPage, activeTab]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setCurrentPage(0);
  }, [debouncedSearch, startDate, endDate, type, coordinates]);

  const activeTabMount = useRef(true);
  useEffect(() => {
    if (activeTabMount.current) {
      activeTabMount.current = false;
      return;
    }
    setSearch("");
    setCurrentPage(0);
    setStartDate("");
    setEndDate("");
  }, [activeTab]);

  const getUrlImage = async (img) => {
    try {
      return await getUrl(img);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id,reason) => {
    try {
      await deleteAdmin(id,reason);
      toast.success("Successfully deleted");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete user");
      console.error(error);
    }
  };

  const handlestatus = async (id) => {
    try {
      const payload = { userId: id };
      await updateAdminStatus(payload);
      toast.success("Status updated successfully");
      fetchAdmins();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update status");
      console.error(error);
    }
  };



  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      const res = await addFile(formData);

      if (res) {
        setPreview(URL.createObjectURL(file));
        setFieldValue("image", res?.data?.data?.fileUrl);
      }
    } catch (error) {
      toast.error("File upload failed");
      setPreview("");
    } finally {
      setUploading(false);
    }
  };

  const openModal = async (admin = null) => {
    setSelectedAdmin(admin);
    setShowModal(true);

    if (admin?.image) {
      try {
        setImageLoading(true);
        const res = await getUrlImage(admin.image);
        setPreview(res?.data?.data);
      } catch (error) {
        console.error(error);
      } finally {
        setImageLoading(false);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedAdmin(null);
    setPreview("");

    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const AdminSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    image: Yup.string().required("image is required"),
  });

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setSubmit(true);
      if (selectedAdmin) {
        const payload = {
          id: selectedAdmin._id,
          name: values.name,
          image: values.image,
        };
        await updateAdminInfo(payload);
        toast.success("Updated successfully");
      } else {
        await createNewAdmin(values);
        toast.success("Added successfully");
        resetForm();
      }
      fetchAdmins();
      setShowModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to save admin");
    } finally {
      setSubmit(false);
    }
  };
  const isFilterActive = search || startDate || endDate  || locationText
  const handleRequest = async (status, id) => {
    try {

      const payload = {
        id: id,
        status: status,
      };
      await verifyUser(payload)
      toast.success(`Request Successfully Verified`);
      fetchAdmins();
    } catch (error) {
      console.error(error);
    }
  };

  const handleClear = () => {
    setSearch("");
    setCoordinates({ lat: "", long: "" });
    setLocationText("");
    setStartDate("");
    setEndDate("");
    setType("");
  };

  // 🌟 Trigger Confirmation Modal
  const triggerConfirm = (action, id, status = null) => {
    let message = "";
    if (action === "delete") {
      message =
        "Are you sure you want to delete this record? This action cannot be undone.";
    } else if (action === "status") {
      message = `Are you sure you want to ${status.toLowerCase()} this account?`;
    } else if (action === "Verified") {
      message = `Are you sure you want to verify this user's request?`;
    }
    else if (action === "Reject") {
      message = `Are you sure you want to reject this user's request?`;
    }

    setConfirmState({ show: true, action, id, status, message });
  };

  // 🌟 Execute Action After Confirmation
  const confirmActionHandler = () => {
    const { action, id, status } = confirmState;
   
  if (action === "delete" && !deleteReason.trim()) {
    toast.error("Please enter a reason");
    return;
  }

  if (action === "delete") {
    handleDelete(id, deleteReason);
    } else if (action === "status") {
      handlestatus(id);
    } else if (action === "Verified") {
      handleRequest("Verified", id);
    }
    else if (action === "Reject") {
      handleRequest("Reject", id);
    }

    setConfirmState({
      show: false,
      action: null,
      id: null,
      status: null,
      message: "",
    });
  };

  const openExportModal = () => {
    setExportStartDate(startDate || "");
    setExportEndDate(endDate || "");
    setExportStatus(type || "");
    setShowExportModal(true);
  };

  const handleExportSubmit = async (e) => {
    e.preventDefault();
    if (!exportStartDate || !exportEndDate) {
      toast.error("Start Date and End Date are compulsory for export");
      return;
    }

    if (exportStartDate > exportEndDate) {
      toast.error("Start Date cannot be after End Date");
      return;
    }

    try {
      setExportLoading(true);
      const res = await exportSafetyCheckList(
        exportStartDate,
        exportEndDate,
        exportStatus
      );

      const rawData = res?.data?.data;
      let safetyCheckList = [];
      if (Array.isArray(rawData)) {
        safetyCheckList = rawData;
      } else if (rawData?.data && Array.isArray(rawData.data)) {
        safetyCheckList = rawData.data;
      } else if (rawData?.safetyChecks && Array.isArray(rawData.safetyChecks)) {
        safetyCheckList = rawData.safetyChecks;
      } else if (rawData?.safetyCheckList && Array.isArray(rawData.safetyCheckList)) {
        safetyCheckList = rawData.safetyCheckList;
      }

      if (!safetyCheckList || safetyCheckList.length === 0) {
        toast.error("No safety check records found for the selected criteria");
        return;
      }

      const csvData = safetyCheckList.map((admin, index) => {
        const flat = admin.ad?.title
          ? `${admin.ad.title.charAt(0).toUpperCase()}${admin.ad.title.slice(1)}`
          : "_";

        const client = admin.user?.name
          ? `${admin.user.name.charAt(0).toUpperCase()}${admin.user.name.slice(1)}`
          : "_";

        const phone = admin.user?.phoneNumber
          ? `${admin.user.countryCode || ""} ${admin.user.phoneNumber}`.trim()
          : "_";

        const visitedDateTime = admin.visitDateTime
          ? new Date(admin.visitDateTime).toLocaleString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "_";

        const duration = admin.durationHours
          ? `${admin.durationHours} ${admin.durationHours === 1 ? "hour" : "hours"}`
          : "_";

        const visitStatus = admin.status
          ? admin.status === "Active"
            ? "On Visit"
            : admin.status
          : "_";

        let trustedContact = "_";
        if (Array.isArray(admin.trustedContacts) && admin.trustedContacts.length > 0) {
          trustedContact = admin.trustedContacts
            .map(
              (c) =>
                `${c.name ? c.name.charAt(0).toUpperCase() + c.name.slice(1) : ""} (${c.phoneNumber || ""})`
            )
            .join("; ");
        }

        return {
          "Sr No.": index + 1,
          Flat: flat,
          Client: client,
          "Phone Number": phone,
          "Visited Date & Time": visitedDateTime,
          Duration: duration,
          "Visit Status": visitStatus,
          "Trusted Contact": trustedContact,
        };
      });

      if (exportType === "excel") {
        const worksheet = XLSX.utils.json_to_sheet(csvData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Safety Checks");
        XLSX.writeFile(
          workbook,
          `safety_checks_export_${exportStartDate}_to_${exportEndDate}.xlsx`
        );
        toast.success("Excel exported successfully");
      } else {
        const headers = Object.keys(csvData[0]);
        const csvContent = [
          headers.join(","),
          ...csvData.map((row) =>
            headers
              .map((header) => `"${String(row[header] ?? "").replace(/"/g, '""')}"`)
              .join(",")
          ),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute(
          "download",
          `safety_checks_export_${exportStartDate}_to_${exportEndDate}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success("CSV exported successfully");
      }
      setShowExportModal(false);
    } catch (error) {
      console.error("Export Error:", error);
      toast.error(error?.response?.data?.message || "Failed to export data");
    } finally {
      setExportLoading(false);
    }
  };

  const today = new Date().toISOString().split("T")[0];


  return (
    <div className="container mt-4">
   <div className="d-flex justify-content-between align-items-center mb-3">
        <h1 style={{ color: "#E5484D" }}>Safety Checks</h1>
        
        <button
          onClick={openExportModal}
          className="btn btn-sm text-white d-flex align-items-center gap-2 shadow-sm px-3 py-2"
          style={{ backgroundColor: "#E5484D", borderRadius: "0.5rem", border: "none" }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export Safety Checks
        </button>
      </div>



   {/* <Row>
        {topMetrics.map((metric, idx) => (
          <Col md={4} key={idx}>
            <MetricCard title={metric.title} value={metric.value}  icon={metric.icon} />
          </Col>
        ))}
      </Row> */}



      <div className="pb-2 d-flex flex-wrap justify-content-end gap-2 align-items-end mb-4">
        <div>
          <label className="form-label mb-1" style={{ fontSize: "12px", color: "#6c757d" }}>
            Status
          </label>

          <select
            className="form-control"
            value={type}
            style={{
              borderRadius: "0.5rem",
              borderColor: "#E5484D",
              height: "42px",
              minWidth: "160px",
              paddingRight: "2rem",
            }}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">All</option>
            <option value="Active">On Visit</option>
            <option value="ClockedOut">Clocked Out</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>

        {isFilterActive && (
          <div>
            <button
              className="btn btn-outline-danger"
              onClick={handleClear}
              style={{ borderRadius: "0.5rem", height: "42px" }}
            >
              Clear
            </button>
          </div>
        )}
      </div>

  
          {loading ? (
            <Spinner />
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle shadow-sm">
                <thead className="table-light">
                  <tr>
                    <th>Sr No.</th>
                    <th>FLat</th>
                    <th>CLient</th>
                        <th>Phone Number</th>
                    <th>Visited Date & Time</th>
                         <th>Duration</th>
                    <th>Visit Status</th>
                    <th style={{ minWidth: "180px" }}>Trusted Contact</th>
                  </tr>
                </thead>
                <tbody>
                  {admins?.length > 0 ? (
                    admins.map((admin, index) => (
                      <tr className={admin.status?.toLowerCase() === "overdue" ? "overdue-row" : ""} key={admin._id || index}>
                        <td>{currentPage * itemsPerPage + index + 1}</td>
                        <td className="text-primary cursor-pointer" onClick={()=> 
                         user?.type ==="Admin" ?  navigate(`/listing-detail/${admin?.ad?._id}`)  :  roleData?.adsManagement?.isRead ? navigate(`/listing-detail/${admin?.ad?._id}`):""
                           }>
                          {admin.ad
                            ? `${admin.ad.title
                                .charAt(0)
                                .toUpperCase()}${admin.ad.title.slice(1)}`
                            : "_"}
                        </td>
                      <td className="text-primary cursor-pointer"   onClick={() => {
  if(user?.type ==="Admin"){
    navigate(`/user-detail/${admin?.user?._id}`);
  }
   else if (
      roleData?.misManagement?.isRead ||
      roleData?.userManagement?.isRead
    ) {
      navigate(`/user-detail/${admin?.user?._id}`);
    }
  }}>{admin.user
                            ? `${admin.user.name
                                .charAt(0)
                                .toUpperCase()}${admin.user.name.slice(1)}`
                            : "_"}</td>
                        <td>
                          {admin.user.phoneNumber
                            ? `${admin.user.countryCode || ""}  ${admin.user.phoneNumber}`
                            : "_"}
                        </td>
                        <td>{admin.visitDateTime ?  new Date(admin.visitDateTime).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }): "_"}</td>
                        <td>
                         {admin.durationHours ? admin.durationHours : "_"} {admin.durationHours ? admin.durationHours ===1 ? "hour" : "hours" : "_"}
                        </td>
   
                       <td>
  {admin.status ? (
    <span
      className={`badge text-white ${
        admin.status === "Active"
          ? "bg-success"
          : admin.status === "Overdue"
          ? "bg-danger"
          : admin.status === "ClockedOut"
          ? "bg-secondary"
          : "bg-primary"
      }`}
    >
      {admin.status === "Active" ? "On Visit" : admin.status}
    </span>
  ) : (
    "_"
  )}
</td>

{/* 
                         <td>
                          {admin.adminApprove === "Reject" ? "Rejected" : admin.adminApprove }
                        </td> */}
                       
                      <td>
                        <ReadMoreContacts contacts={admin?.trustedContacts} />
                      </td>
                      
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        No data found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
      

      <div className="card-footer clearfix mt-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start">
        <div
            className="dataTables_info fw-bold mb-3 mb-md-0"
            style={{ color: "#E5484D" }}
          >Total Checks : {totalItems}</div>
          <div className="d-flex align-items-center">
            {totalPages > 0 && (
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            )}
          </div>
        </div>
      </div>

      {/* Main Edit/Add Modal */}
      <Modal size="xl" show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedAdmin ? "Edit User" : "Add User"}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={
            selectedAdmin
              ? {
                  userId: selectedAdmin._id,
                  name: selectedAdmin.name || "",
                  image: selectedAdmin.image || "",
                }
              : {
                  name: "",
                  image: "",
                }
          }
          enableReinitialize
          validationSchema={AdminSchema}
          onSubmit={handleSubmit}
        >
          {({ errors, touched, values, setFieldValue }) => (
            <FormikForm>
              <Modal.Body>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <Field
                    name="name"
                    placeholder="ex. John Doe"
                    className={`form-control ${
                      errors.name && touched.name ? "is-invalid" : ""
                    }`}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Image</label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    ref={fileInputRef}
                    onChange={(e) =>
                      handleFileUpload(e, "image", setFieldValue)
                    }
                  />
                  <ErrorMessage
                    name="image"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>

                {uploading ? (
                  <div className="text-success mt-2">Uploading image...</div>
                ) : imageLoading ? (
                  <div>loading...</div>
                ) : (
                  preview && (
                    <div className="mb-3 text-center mt-3">
                      <div
                        style={{
                          display: "inline-block",
                          position: "relative",
                        }}
                      >
                        <img
                          src={preview}
                          alt="preview"
                          style={{
                            width: "120px",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                            border: "1px solid #ddd",
                          }}
                        />
                        <button
                          type="button"
                          className="btn btn-danger btn-sm shadow"
                          style={{
                            position: "absolute",
                            top: "-8px",
                            right: "-8px",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            padding: "0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            lineHeight: "1",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                          onClick={() => {
                            setPreview("");
                            if (fileInputRef.current)
                              fileInputRef.current.value = "";
                            setFieldValue("image", "");
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    </div>
                  )
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                  Close
                </Button>
                <Button
                  type="submit"
                  style={{ backgroundColor: " #FFE4E6", border: "none" }}
                  disabled={uploading}
                >
                  {submit ? "Saving" : "Save Changes"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>

      {/* 🌟 New Confirmation Modal */}
      <Modal
        show={confirmState.show}
        onHide={() => setConfirmState({ ...confirmState, show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0 fs-5">{confirmState.message}</p>

         {confirmState.action === "delete" && (
  <div className="mt-3">
    <label className="form-label fw-bold">
      Reason for deletion <span className="text-danger">*</span>
    </label>
    <textarea
      className="form-control"
      rows={3}
      placeholder="Enter reason..."
      value={deleteReason}
      onChange={(e) => setDeleteReason(e.target.value)}
    />
  </div>
)}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmState({ ...confirmState, show: false })}
          >
            Cancel
          </Button>
          <Button
            variant={
              confirmState.action === "delete" ||
              confirmState.status === "Reject"
                ? "danger"
                : "primary"
            }
            style={
              confirmState.action !== "delete" &&
              confirmState.status !== "Reject"
                ? {
                    backgroundColor: "#E5484D",
                    borderColor: "#FFE4E6",
                    color: "white",
                  }
                : {}
            }
            onClick={confirmActionHandler}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🌟 Export Modal */}
      <Modal
        show={showExportModal}
        onHide={() => setShowExportModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#E5484D" }}>Export Safety Checks Data</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleExportSubmit}>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label fw-bold">Export Format</label>
              <select
                className="form-select"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                value={exportType}
                onChange={(e) => setExportType(e.target.value)}
              >
                <option value="excel">Excel (.xlsx)</option>
                <option value="csv">CSV (.csv)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                Start Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                max={today}
                value={exportStartDate}
                onChange={(e) => {
                  setExportStartDate(e.target.value);
                  if (exportEndDate && e.target.value > exportEndDate) {
                    setExportEndDate("");
                  }
                }}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                End Date <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                className="form-control"
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                min={exportStartDate}
                max={today}
                value={exportEndDate}
                onChange={(e) => setExportEndDate(e.target.value)}
                disabled={!exportStartDate}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">
                Status <span className="text-muted fw-normal">(Optional)</span>
              </label>
              <select
                className="form-control"
                value={exportStatus}
                style={{ borderRadius: "0.5rem", borderColor: "#E5484D" }}
                onChange={(e) => setExportStatus(e.target.value)}
              >
                <option value="">All</option>
                <option value="Active">On Visit</option>
                <option value="ClockedOut">Clocked Out</option>
                <option value="Overdue">Overdue</option>
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowExportModal(false)}
              disabled={exportLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={exportLoading}
              style={{
                backgroundColor: exportType === "excel" ? "#21a366" : "#E5484D",
                borderColor: exportType === "excel" ? "#21a366" : "#E5484D",
                color: "white",
              }}
            >
              {exportLoading ? "Exporting..." : exportType === "excel" ? "Export Excel" : "Export CSV"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

   
    </div>
  );
};

export default SafetyChecks;

